import { atom } from "recoil";

export interface UserPromotionType {
  accessToken?: string;
  nickname?: string;
  email?: string;
  userId?: number;
  trackId?: string;
  authenticateType?: string;
  isSubscribing?: boolean;
}

export const userPromotionAtom = atom<UserPromotionType | undefined>({
  key: "userPromotion",
  default: undefined,
  // accessToken은 메모리에만 저장 (XSS 공격 방지)
  // refreshToken은 httpOnly 쿠키로 서버에서 관리
});
